<template>

<!--
    <b-input-group>
        <b-form-datepicker v-model="datepick" :locale="locale" size="sm" start-weekday="1" v-bind="dateTranslations || {}"
            :disabled="disabled"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" />
        <b-form-timepicker v-model="timepick" :locale="locale" size="sm" :hour12="false" v-bind="timeTranslations || {}"
            :disabled="disabled" />
    </b-input-group>
-->

    <b-row>
        <b-col>
            <b-form-datepicker v-model="datepick" :locale="locale" size="sm" start-weekday="1" v-bind="dateTranslations || {}"
                :disabled="disabled"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" />
        </b-col>
        <b-col>
             <b-form-timepicker class='tp' v-model="timepick" :locale="locale" size="sm" :hour12="false" v-bind="timeTranslations || {}"
                :disabled="disabled" />
        </b-col>
    </b-row>

</template>

<script>
import moment from 'moment';

export default {
    name: 'DateTimePicker',
    props: {
        value: {
            type: String,
            default: new moment().format('YYYY-MM-DD[T]HH:mm:ssZZ')
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        locale: function() {
            return this.$t('datepicker.locale');
        },
        dateTranslations: function() {
            return this.$t('datepicker');
        },
        timeTranslations: function() {
            return this.$t('timepicker');
        },
        datepick: {
            get() {
                var m = new moment(this.value, 'YYYY-MM-DD[T]HH:mm:ssZZ');
                if (m.isValid()) {
                    return m.format('YYYY-MM-DD');
                }
                return '';
            },
            set(newDate) {
                var m = new moment(newDate + this.timepick, 'YYYY-MM-DDHH:mm:ss');
                if (m.isValid()) {
                    this.$emit('input', m.format('YYYY-MM-DD[T]HH:mm:ssZZ'));
                }
            }
        },
        timepick: {
            get() {
                var m = new moment(this.value, 'YYYY-MM-DD[T]HH:mm:ssZZ');
                if (m.isValid()) {
                    return m.format('HH:mm:ss');
                }
                return '';
            },
            set(newTime) {
                var m = new moment(this.datepick + newTime, 'YYYY-MM-DDHH:mm:ss');
                if (m.isValid()) {
                    this.$emit('input', m.format('YYYY-MM-DD[T]HH:mm:ssZZ'));
                }
            }
        }
    },
    created() {
        // Initialize "v-model" to the default value set for this component in the props object.
        var m = new moment(this.datepick + this.timepick, 'YYYY-MM-DDHH:mm:ss');
        if (m.isValid()) {
            this.$emit('input', m.format('YYYY-MM-DD[T]HH:mm:ssZZ'));
        }
    }
}
</script>

<style scoped lang="scss">

.tp {
    padding: 0px;
}

</style>